import { createFileRoute } from "@tanstack/react-router";
import { ScribePage } from "shared/components/global/Scribe/ScribePage";

/** @public */
export const Route = createFileRoute("/_auth/help/users")({
    component: () => <ScribePage src="https://scribehow.com/page-embed/User_Management__SuR4gjkeS6Ckvp2ejFRRlQ" />,
});
